<ng-container *ngIf="loading">
    <mapfre-loading></mapfre-loading>
</ng-container>
<ng-container *ngIf="!loading">
    <mapfre-card [singleCard]="false" [additionalClasses]="'billing-refund fs-18 lh-24'">
        <div class="border-bottom-1-9CB0BC fs-16  mb-4">
            <h1 class="title-copy mb-0 dm-sans">{{ "REFUNDS" | translate }}</h1>
            <p class="mb-0 lh-20-83 margin-vertical mv16 col-526570">
                {{ "REFUND_AMOUNTS_ARE_THE_DIFFERENCE" | translate }}
            </p>
        </div>

        <app-billing-header 
            [policyTypeImg]="policyTypeImg" [policyType]="policyType" 
            [policyNumber]="policy?.policynumber.policyNumber" [policy]="policy"
        >
        </app-billing-header>
        
        <form name="billingDiscountForm" class="ng-select-main submit-question-form" [formGroup]="billingDiscountForm"
            (ngSubmit)="billingDiscountForm?.valid && sendQuestion()" [ngClass]="{'text-left ma-submit-question-form': !isAcmic}">
            <div class="margin-top mt16 fs-16">
                <label for="select-policy" class="select-label mb-0">{{ "SELECT_TOPIC" | translate }}</label>
                <ng-select 
                [items]="topicOptions" 
                bindLabel="name" 
                autofocus 
                bindValue="name" 
                [searchable]="false" 
                [multiple]="false"
                [clearable]="false" 
                [markFirst]="false" 
                placeholder="Select one" 
                fixedPlaceholder="true"
                [formControlName]="'topic'"
                (change)="onTopicChange()"> 
                </ng-select>
            </div>
            <div *ngIf="billingDiscountForm.controls.topic.value ==='Select one'"
                class="error-block form-control no-padding-left no-padding-top border border-0 rounded-0 h-auto">
                {{ 'SELECTION_IS_REQUIRED' | translate }}
            </div>

            <ng-container *ngIf="billingDiscountForm.controls.topic.value !== null">
                <div class="margin-top mt24 fs-16">
                    <label for="select-policy" class="select-label mb-0">{{ "SELECT_REASON_STAR" | translate }}</label>
                    <ng-select 
                    [items]="reasonOptions" 
                    bindLabel="name" 
                    autofocus 
                    bindValue="name" 
                    [searchable]="false" 
                    [multiple]="false"
                    [clearable]="false" 
                    [markFirst]="false" 
                    placeholder="Select one" 
                    fixedPlaceholder="true"
                    [formControlName]="'reason'"
                    (click)="onReasonChange()"> 
                    </ng-select>
                </div>
                <div *ngIf="billingDiscountForm.controls.reason.value && billingDiscountForm.controls.reason.value ==='Select one'"
                    class="error-block form-control no-padding-left no-padding-top border border-0 rounded-0 h-auto">
                    {{ 'SELECTION_IS_REQUIRED' | translate }}
                </div>
                <ng-container *ngIf="billingDiscountForm?.controls?.reason?.value ==='New payee'; else otherReasons">
                    <div class="fs-16 mt-4 pb-2">
                        <p>
                            {{ "IF_THE_PAYEE_IS" | translate }}
                            <span class="dm-sans-medium font-weight-700">
                                {{ "INCORRECT_NO_LOGINER" | translate }}
                            </span>
                            {{ "PLEASE" | translate }}
                            <a routerLink="/contact" class="dm-sans-medium font-weight-400 link mapfre red-link underlineBQ">
                                {{ "CONTACT_YOUR_AGENT_LOWERCASE" | translate }}</a>                          
                            {{ "TO_HAVE_THE_POLICY_CORRECTED" | translate }}
                        </p>
                        <p class="col-89969A m-0 mt-4 mb-1">
                            {{ "PAYEE" | translate }}
                        </p>
                        <p class="dm-sans-medium font-weight-500 m-0">
                            <ng-container *ngIf="policy && policy.accountHolder">
                                {{policy.accountHolder.insuredFullName}}
                            </ng-container>
                            <span *ngIf="sniName" class="displayFlexRow">
                                {{sniName}}
                            </span>
                        </p>
                    </div>
                    <div class="row text-center mt-4">
                        <div class="col billing-request-btn">
                            <mapfre-button
                                [additionalClasses]="'basic primary large-btn waves-effect'" (click)="tryAgain(false)">
                                {{ 'CLOSE' | translate }}
                            </mapfre-button>
                        </div>
                    </div>
                </ng-container>
                <ng-template #otherReasons>
                    <app-refund-selected-reason 
                    *ngIf="billingDiscountForm?.controls?.topic?.value === 'Reissue my refund' && billingDiscountForm?.controls?.reason?.value?.length"
                    #refundReason
                    [policyNumber]="policy?.policynumber?.policyNumber"
                    [typeOfReason]="billingDiscountForm.controls.reason.value"
                    (isSubmitActive)="setActiveSubmitButton($event)"
                >
                </app-refund-selected-reason>

                    <ng-container *ngIf="billingDiscountForm?.controls?.topic?.value === 'Question about my refund' && billingDiscountForm?.controls?.reason?.value?.length"
                    >
                    <div *ngIf="billingDiscountForm?.controls?.reason?.value === 'Status'">
                        <div class="blue-msg-box mb-4">
                            <div class="icon-section">
                                <img src="./assets/img/images/blue-info-icon.svg" class="blue-info-icon" alt="">
                            </div>
                            <div class="msg-section">
                                <p class="mb-4">
                                    {{ 'QUESTION_ABOUT_MY_REFUND_STATUS_PART_ONE' | translate }}
                                </p>
                                <p class="m-0">
                                    {{ 'QUESTION_ABOUT_MY_REFUND_STATUS_PART_TWO' | translate }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="margin-top mt24">
                        <label for="select-topic" class="select-label mb-0">
                            {{ "ADD_ADDITIONAL_INFO" | translate}}
                        </label>
                        <textarea class="billing-text" placeholder="Type here" #questionAbtMyRefund mdbInput></textarea>
                    </div>
                    </ng-container>
                </ng-template>
            </ng-container>

            <ng-container  *ngIf="billingDiscountForm?.controls?.reason?.value !== 'New payee'">
                <div class="row text-center mt-4 ">
                    <div class="col billing-request-btn">
                        <mapfre-button [ngClass]="{'custom_loader':submitLoading}"
                            [additionalClasses]="'basic primary large-btn waves-effect send-ques-btn-opacity'" [inputType]="'submit'"
                            [disabledValue]="isSubmitActive && billingDiscountForm?.valid"
                            [translateValue]="'SUBMIT' | translate"></mapfre-button>
                    </div>
                </div>    
                <div class="row text-center mt-3">
                    <div class="col billing-request-btn">
                        <mapfre-button [additionalClasses]="'ghost secondary large-btn mx-auto height-56'"
                            [iconClasses]="'align-middle'"
                            (click)="onBack()"
                        >
                            {{ 'BACK' | translate }}
                        </mapfre-button>
                    </div>
                </div>
            </ng-container>
        </form>
    </mapfre-card>
</ng-container>

<mapfre-modal
  *ngIf="showFailureModal"
      [modalOptions]="failureSubmitModal"
      [hideModal]="hideModal"
      (closeModal)="resetHideModal()"
    >
    <app-request-unsuccess
        (isTryAgain)="tryAgain($event)">
    </app-request-unsuccess>
</mapfre-modal>